// skipcq: JS-W1028
import { useCallback, useId, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function DashboardSectionInfo({ children, 'aria-label': ariaLabel }) {
  const popoverId = useId();
  const [anchorElement, setAnchorElement] = useState(null);
  const open = Boolean(anchorElement);

  const handleOpen = useCallback((event) => {
    setAnchorElement(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorElement(null);
  }, []);

  return (
    <>
      <IconButton
        size="small"
        onClick={handleOpen}
        aria-label={ariaLabel}
        aria-expanded={open}
        aria-describedby={open ? popoverId : undefined}
        sx={{ color: 'text.secondary', p: 0.25 }}
      >
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
      <Popover
        id={popoverId}
        open={open}
        anchorEl={anchorElement}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{
          paper: {
            sx: { maxWidth: 360 },
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body2" component="div" sx={{ color: 'text.secondary' }}>
            {children}
          </Typography>
        </Box>
      </Popover>
    </>
  );
}

DashboardSectionInfo.propTypes = {
  children: PropTypes.node.isRequired,
  'aria-label': PropTypes.string.isRequired,
};

export default DashboardSectionInfo;
